import { render, staticRenderFns } from "./add.vue?vue&type=template&id=54a9f93c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=54a9f93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9f93c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a9f93c')) {
      api.createRecord('54a9f93c', component.options)
    } else {
      api.reload('54a9f93c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=54a9f93c&scoped=true&", function () {
      api.rerender('54a9f93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/components/deposit/add.vue"
export default component.exports